// extracted by mini-css-extract-plugin
module.exports = {"colunaOrdem":"styles_colunaOrdem__1u82r","tituloSecao":"styles_tituloSecao__11n0j","tituloModal":"styles_tituloModal___-3oC"};